import { Pipe, PipeTransform } from '@angular/core';
import { Amenagement } from '../../models/amenagement';

@Pipe({
	name: 'filterAmenagementByName'
})
export class FilterAmenagementByNamePipe implements PipeTransform {
	transform(amenagement: Amenagement[], filter: string): Amenagement[] {
		if (
			!amenagement ||
			!filter ||
			amenagement === null ||
			filter === null ||
			filter === ''
		) {
			return amenagement;
		}

		return amenagement.filter((amenagement: Amenagement) => {
			if (amenagement.name) {
				// TODO: add lastName too
				return amenagement.name.toLowerCase().includes(filter.toLowerCase());
			}
			return false;
		});
	}
}
